import { t } from 'i18next';
import { z } from 'zod';
import { InviteFlowFields } from '../../../consts';
import { ValidateFieldTypes, validationSchemeMap } from '../../../../../helpers/inputUtils.helper';

const MIN_NAME_CHARS = 2;
const MAX_NAME_CHARS = 30;

export interface InviteBaseFormType {
  [InviteFlowFields.EMAIL]: string;
  [InviteFlowFields.FIRST_NAME]: string;
  [InviteFlowFields.LAST_NAME]: string;
}

// TODO: Localise errors / Check with PM
export const emailScheme = z.object({
  [InviteFlowFields.EMAIL]: z.string()
    .min(1, t('errorsEN:EMAIL_REQUIRED'))
    .email(t('errorsEN:EMAIL_INVALID')),
});

export const firstNameScheme = z.object({
  [InviteFlowFields.FIRST_NAME]: z
    .string()
    .trim()
    .min(1, t('errorsEN:FIRST_NAME_REQUIRED'))
    .min(MIN_NAME_CHARS, t('errorsEN:FIRST_NAME_TOO_SHORT'))
    .max(MAX_NAME_CHARS, t('errorsEN:FIRST_NAME_TOO_LONG'))
    .regex(validationSchemeMap[ValidateFieldTypes.FIRST_NAME], t('errorsEN:FIRST_NAME_LETTERS_ONLY')),
});
export const lastNameScheme = z.object({
  [InviteFlowFields.LAST_NAME]: z
    .string()
    .trim()
    .min(1, t('errorsEN:LAST_NAME_REQUIRED'))
    .min(MIN_NAME_CHARS, t('errorsEN:LAST_NAME_REQUIRED'))
    .max(MAX_NAME_CHARS, t('errorsEN:LAST_NAME_TOO_LONG'))
    .regex(validationSchemeMap[ValidateFieldTypes.LAST_NAME], t('errorsEN:LAST_NAME_TOO_SHORT')),
});
export const baseScheme = z.object({
  ...emailScheme.shape,
  ...firstNameScheme.shape,
  ...lastNameScheme.shape,
});

export const baseSchemeDefaultValue = {
  [InviteFlowFields.EMAIL]: '',
  [InviteFlowFields.LAST_NAME]: '',
  [InviteFlowFields.FIRST_NAME]: '',
};
